module.exports = __webpack_public_path__ + "img/course4.d5e37af3.png";